
namespace TabAurous.Inventory {

    @Serenity.Decorators.registerClass()
    export class MaterialReceiptItemsGrid extends Serenity.EntityGrid<MaterialReceiptItemsRow, any> {
        protected getColumnsKey() { return 'Inventory.MaterialReceiptItems'; }
        protected getDialogType() { return MaterialReceiptItemsDialog; }
        protected getIdProperty() { return MaterialReceiptItemsRow.idProperty; }
        protected getInsertPermission() { return MaterialReceiptItemsRow.insertPermission; }
        protected getLocalTextPrefix() { return MaterialReceiptItemsRow.localTextPrefix; }
        protected getService() { return MaterialReceiptItemsService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
       
        }

        protected getSlickOptions() {
            let opt = super.getSlickOptions();
            opt.editable = true;
            opt.autoEdit = true;
            //opt.forceFitColumns = true;
            return opt;
        }
        
    }
}